import { Component, OnInit, HostListener, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalsService } from '../common/services/globals.service';
import { SharedService } from '../common/services/shared.service';
import Stepper from 'bs-stepper';
import { DatePipe, PlatformLocation } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Payment } from '../common/payment';
import { PaymentPayload, ACHPaymentDetailObj, CCPaymentDetailObj } from '../common/paymentpayload';
import { PaymentDetailObj } from '../common/paymentpayload';
import { CookieService } from "angular2-cookie/core";
import { AdverseNotoficationComponent } from '../adverse-notification/adverse-notification.component';
import { NgxSpinnerService } from 'ngx-spinner';

declare var $: any
// import { globalAgent } from 'http';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { prefillHostVars } from '@angular/core/src/render3/instructions';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-main',
  templateUrl: './sbe.component.html',
  styleUrls: ['./sbe.component.css']
})



export class SbeComponent implements OnInit {
  @ViewChild('dataContainer') dataContainer: ElementRef;
  date = new Date();
  currentDate = new Date();
  payment: Payment = {};
  paymentForm: FormGroup;
  private stepper: Stepper;
  fieldValidity: Map<string, string> = new Map<string, string>();
  numericReg = /^\d+$/;
  pureAlphaNumericPattern = /^[a-zA-Z0-9 ]*[a-zA-Z ]+[a-zA-Z0-9 ]*$/;
  products: Array<Product> = new Array<Product>()
  //totalAmountDue: number;
  billingAddrIsDifferent: boolean = false;
  paymentDetailObj: PaymentDetailObj = {};
  paymentPayload: PaymentPayload = {};
  paymentSubmitStatus: boolean = false;
  termsAndConditionsRead: boolean = false;
  modalMsg = '';
  simulationParam: boolean = false;
  iframeURL = "/billing/paynow/assets/" + this.partner + "_terms_conditions.pdf";
  submissionAttempts = 0;
  paymentSelectionMade = false;
  payOnline: boolean = false;
  billMe: boolean = false;
  showSuccessMessage: boolean = false;
  isCardSuppressed: boolean = false;
  moveToStepper: boolean = false;
  AHNJNeedsBilled: boolean = false;
  yearControlTouched: boolean = false;
  monthControlTouched: boolean = false;
  successfulCompletion: boolean = false;
  transactionID_ePay = '';
  loading: boolean = false;
  billingEmailAddrIsDifferent: boolean = false;
  emailSent: boolean = false;
  showAdverseNotification: boolean = false;
  adverseNote: string;
  adverseDetails: any;
  adverseNotificationStatus: boolean = false; 
  failureCount: any;
  agentPaymentAuthorizationIsChecked: boolean = true;
  agentGIACTAuthorizationIsChecked: boolean = true;
  showSendMeBill = true;
  cardDigit = '3';
  emailFieldValid = false;
  accountLength;
  routingLength = Array(6);
  cardLength = Array(12);
  authDate = new Date();
  w3llsendMeBill = false;

  app_Partner = {isFFM: false, partner: ''}

  @ViewChild('submitButton') public submitButton: ElementRef;

  @ViewChild(AdverseNotoficationComponent)
  child: AdverseNotoficationComponent;

  sbe_recent_pmt_flag: boolean = false;

  phoneNum: string;

  @HostListener('window:beforeunload', ['$event'])
  doSomething($event) {
    if (!this.successfulCompletion) {
      $event.returnValue = 'Your data will be lost!';
    }
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    if ((Math.abs(event.target.scrollTop - (event.target.scrollHeight - event.target.offsetHeight))) < (event.target.scrollHeight * 0.5)) {
      this.termsAndConditionsRead = true;
    }
  }

  get TCLink() {
    if (GlobalsService.language == null || GlobalsService.language == '' || GlobalsService.language == 'EN') {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    } else if(GlobalsService.language == 'ES') {
       if(GlobalsService.partner === 'AHNJ') {
        return "../../../billing/paynow/assets/ES_ePAY_T&C.pdf";
      }
    }
  }

  log() {
    console.log("Preventing double click");

  }

  cancel() {
    // Maintain FFM/SP status and partner logo details if user clicks on exit from FFM/SP portal
    if(location.href.includes("ffm")) {

      this.app_Partner.partner = this.app_Partner.isFFM && location.href.indexOf("=")!== -1? 
      location.href.slice(location.href.indexOf("=")+1, location.href.indexOf("&")):'highmark';

      localStorage.setItem('isFFM', JSON.stringify(true))
      localStorage.setItem('partner',this.app_Partner.partner)
    }
    $('#SBERecentPaymentModal').modal('hide');
    $('#SBERecentPaymentModalIBC').modal('hide');
    this.router.navigate(['/done']);
  }

  makeNewPayment() {
    $('#SBERecentPaymentModal').modal('hide');
    $('#SBERecentPaymentModalIBC').modal('hide');
  }

  get TransactionID_ePay() {
    return this.transactionID_ePay;
  }

  get TransactionID_SBE() {
    return GlobalsService.sbe_saml.ConsumerReferenceID;
  }

  yearControlChanged() {
    this.yearControlTouched = true;
  }

  monthControlChanged() {
    this.monthControlTouched = true;
  }

  continueToStepper() {
    this.paymentSelectionMade = true;
    this.moveToStepper = true;
  }

  get showBillMeConfirmation() {
    if (this.billMe == true && (GlobalsService.partner == 'HHP' || GlobalsService.partner == 'MN' || GlobalsService.partner == 'ND' || GlobalsService.partner == 'WY' || GlobalsService.partner == 'IBC') && this.paymentSelectionMade == true) {
      return true;
    } else {
      if (this.AHNJNeedsBilled) {
        return true;
      }
      return false;
    }
  }

  submitBillMe() {
    //Natalie TODO

    //Process request to send bill in mail
    var requestBillPayload = { "ApplicationID": GlobalsService.SBE_ApplicationID, "ConsumerReferenceID": GlobalsService.SBE_ConsumerReferenceID };
    this.http.post<any>(this.sharedService.getURI('requestabill'), JSON.stringify(requestBillPayload)).subscribe(data => {
      if (data.status == true) {
        console.log("Successful bill request for ApplicationID = " + GlobalsService.SBE_ApplicationID);
        //this.router.navigate(['/done']);
      } else {
        console.log("Unsuccessful bill request for ApplicationID = " + GlobalsService.SBE_ApplicationID);
      }
    },
      (error => {
        console.log('Unsuccessful bill request for ApplicationID = ' + GlobalsService.SBE_ApplicationID);
      }));
    //Show confirmation popup
    this.showSuccessMessage = true;
    this.successfulCompletion = true;
    if(location.href.includes("w3ll")) {
      this.w3llsendMeBill = true;
    }
  }


  get showStepper() {
    if (this.billMe == true) {
      return false;
    }
    if(location.href.includes("w3ll")) {
      return true;
    }
    if ((GlobalsService.partner == 'HHP' || GlobalsService.partner == 'MN' || GlobalsService.partner == 'ND' || GlobalsService.partner == 'WY' || GlobalsService.partner == 'IBC') && (this.paymentSelectionMade == false)) {
      return false;
    } else {
      if (GlobalsService.partner == 'AHNJ' && !this.moveToStepper) {
        return false;
      }
      return true;
    }

  }

  get partnerEbillLogo() {
    if (GlobalsService.activePartner === 'WNY') {
      return "/billing/paynow/assets/img/HMWNY_EBILL_Logo.png";
    } else if (GlobalsService.activePartner === 'NENY') {
      return "/billing/paynow/assets/img/HMNENY_EBILL_Logo.png";
    }  else if(location.href.includes("ffm")){
      let dummy = this.app_Partner.isFFM && location.href.indexOf("=")!== -1?
          location.href.slice(location.href.indexOf("=")+1, location.href.indexOf("&")):'highmark';
      return "/billing/paynow/assets/img/" + dummy.toUpperCase() + "_EBILL_Logo.png";
    } else {
      return "/billing/paynow/assets/img/" + GlobalsService.partner + "_EBILL_Logo.png";
    }
  }

  get ModalMsg() {
    return this.modalMsg;
  }

  get productCount() {
    return this.products.length;
  }

  get pmtTransactionID() {
    return GlobalsService.SBE_ApplicationID;
  }

  get planEfftDate() {
    return GlobalsService.sbe_saml.ProposedCoverageEffectiveDate;
  }

  get businessName() {
    return GlobalsService.businessName;
  }

  get pcpIndicator() {
    return GlobalsService.pcpIndicator;
  }

  get ssnValue() {
    return GlobalsService.sbe_saml.PartnerAssignedConsumerID;
  }

  constructor(
    private _global: GlobalsService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private location: PlatformLocation,
    private gservice: GlobalsService,
    private cookieService: CookieService,
    private cdRef:ChangeDetectorRef,
    private spinner: NgxSpinnerService
  ) {
    location.onPopState(() => {
      if (location.hash.includes('simulation=true')) {
    $('#SBEConnErrModal').modal('hide');
      } else {
        this.router.navigate['/done'];
      }
    });
  }

  ngOnInit() {

    this.payment.contactEmailAddress = GlobalsService.sbe_saml.ContactEmailAddress;
    let latest_date = new DatePipe('en-Us').transform(new Date(), 'yyyy-MM-dd');
    let parts = latest_date.split("-");
    let mustYrs = parseInt(parts[0]) - 14;
    parts[0] = mustYrs.toString();
    let min14yrs = new Date(parts[0] + "/" + parts[1] + "/" + parts[2]);
    this.currentDate = min14yrs;


    this.gservice.getValue().subscribe((value) => {
      this.sbe_recent_pmt_flag = value;
      let tempBalance: number = +GlobalsService.sbe_saml.TotalAmountOwed;
      if (this.sbe_recent_pmt_flag && tempBalance > 0) {
        if (GlobalsService.partner == 'HHP') {
          $('#SBERecentPaymentModal').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
        } else {
          $('#SBERecentPaymentModalIBC').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
        }
      }
    });

    this.gservice.getValueInvalidData().subscribe((value) => {
      if (value) {
        this.callUnavailableModal();
      }
    });

    // get the route params
    this.route.queryParams.subscribe(params => {
      this.simulationParam = (params['simulation'] === 'true') ? true : false;
    });

    this.stepper = new Stepper(document.querySelector('#stepper1'), {
      linear: false,
      animation: true
    });

    this.resetErrorMsgs();

    this.paymentForm = this.formBuilder.group({
      paymentType: ['', Validators.required],
      routingNumber: [''],
      dateOfBirth: [''],
      accountNumber: [''],
      accountNumberConfirmation: [''],
      paymentAmount: [''],
      achType: [''],
      bankaccountType: [''],
      businessName: [''],
      cardNumber: [''],
      accountHolderFirstName: [''],
      accountHolderLastName: [''],
      billingAndPrimaryAddrMatch: [''],
      cardType: [''],
      debitType: [''],
      expMonth: [''],
      expYear: [''],
      addrLine1: [''],
      addrLine2: [''],
      city: [''],
      state: [''],
      zip: [''],
      contactEmailAddress: [''],
      cvv: ['']
    }, {
        validator: this.MustMatch('accountNumber', 'accountNumberConfirmation')
      });

      this.payment.accountHolderType = 'personal';

      let temp: number = +GlobalsService.sbe_saml.TotalAmountOwed;
      if (temp === 0.00 || temp < 0.00)
      { 
        $('#zeroDueModal').modal({
          backdrop: 'static',
          keyboard: false,
          show: true
        }); } 
  }

  // ngAfterViewInit() {

  //   this.cdRef.detectChanges();
  //    }

  resetErrorMsgs() {
    this.fieldValidity.set('paymentType', '');
    this.fieldValidity.set('accountHolderFirstName', '');
    this.fieldValidity.set('accountHolderLastName', '');
    this.fieldValidity.set('achType', '');
    this.fieldValidity.set('bankaccountType', '');
    this.fieldValidity.set('businessName', '');
    this.fieldValidity.set('routingNumber', '');
    this.fieldValidity.set('dateOfBirth', '');
    this.fieldValidity.set('accountNumber', '');
    this.fieldValidity.set('accountNumberConfirmation', '');
    this.fieldValidity.set('cardType', '');
    this.fieldValidity.set('cardNumber', '');
    this.fieldValidity.set('addrLine1', '');
    this.fieldValidity.set('addrLine2', '');
    this.fieldValidity.set('city', '');
    this.fieldValidity.set('state', '');
    this.fieldValidity.set('zip', '');
    this.fieldValidity.set('contactEmailAddress', '');
    this.fieldValidity.set('cvv', '');
  }

  toggleBillingAddr() {
    this.billingAddrIsDifferent = !this.billingAddrIsDifferent;
  }

  toggleEmailBillingAddr() {
    this.billingEmailAddrIsDifferent = !this.billingEmailAddrIsDifferent;
    if(this.billingEmailAddrIsDifferent) {
     
      if(this.payment.contactEmailAddress == '' || this.payment.contactEmailAddress == null || this.fieldValidity.get('contactEmailAddress') != '') {
        this.emailFieldValid = true;
      } else {
        this.emailFieldValid = false;
      }
    } else {
      this.emailFieldValid = false;
    }
    
  }

  paymentToggleEmailBillingAddr(authorizationtype) {
    if (authorizationtype === 'PaymentAuthorization') {
      this.agentPaymentAuthorizationIsChecked = !this.agentPaymentAuthorizationIsChecked;
    } else if (authorizationtype === 'GIACTAuthorization') {
      this.agentGIACTAuthorizationIsChecked = !this.agentGIACTAuthorizationIsChecked
    }    
  }

  selectPayOnlineOption() {
    this.payOnline = true;
    this.billMe = false;
  }

  get LastPaymentDate() {
    return GlobalsService.SBE_LastPaymentDate;
  }

  get LastPaymentAmount() {
    return GlobalsService.SBE_LastPaymentAmount;
  }

  get LastProposedCoverageEffectDate() {
    return GlobalsService.SBE_LastProposedCoverageEffectDate;
  }

  get LastProposedCoverageEffectDateW3LL() {
    return GlobalsService.sbe_saml.ProposedCoverageEffectiveDate;
  }

  finished() {
    $('#paymentModalGetBillIBC').modal('hide');
    this.router.navigate(['/done']);
  }
  selectZeroBillMeOption() {
    $('#zeroDueModal').modal('hide');
    this.paymentSelectionMade = true;
    this.billMe = true;
    this.payOnline = false;
  }

  selectBillMeOption() {
    $('#paymentModalGetBill').modal('hide');
    $('#paymentModalGetBillIBC').modal('hide');
    if (GlobalsService.partner == 'AHNJ') {
      $('#paymentModalRetry').modal('hide');
      $('#paymentModalRetryAHNJ').modal('hide');
      $('#paymentModalRetryACH').modal('hide');
      $('#duplicateModalRetry').modal('hide');
      this.stepper.reset();
      this.AHNJNeedsBilled = true;
      this.showSuccessMessage = false;
      this.billMe = true;
      this.payOnline = false;
    } else {
      this.backToFirstScreen();
    }
    this.billMe = true;
    this.payOnline = false;
  }

  get partner() {
    return GlobalsService.partner;
  }

  get activePartner() {
    return GlobalsService.activePartner;
  }

  get billingAddrDiffers() {
    return this.billingAddrIsDifferent;
  }

  get billingEmailAddrDiffers() {
    return this.billingEmailAddrIsDifferent;
  }

  get suppressCard() {
    /*if (GlobalsService.saml.SuppressCreditCard.includes('Y')) {
      return true;
    } else {
      return false;
    }
    */
    return this.isCardSuppressed;
  }

  get userType(){
    return GlobalsService.sbe_saml.UserType
  }

  get memberAddress() {
    if(GlobalsService.sbe_saml.StreetName2 === undefined || GlobalsService.sbe_saml.StreetName2 === null || GlobalsService.sbe_saml.StreetName2 === ''){
      return GlobalsService.sbe_saml.StreetName1 + ' - ' +
          GlobalsService.sbe_saml.CityName + ', ' + GlobalsService.sbe_saml.State + ', ' + GlobalsService.sbe_saml.ZipCode;
    }
    else{
      return GlobalsService.sbe_saml.StreetName1 + ', ' + GlobalsService.sbe_saml.StreetName2 + ' - ' +
          GlobalsService.sbe_saml.CityName + ', ' + GlobalsService.sbe_saml.State + ', ' + GlobalsService.sbe_saml.ZipCode;
    }
  }


  get language() {
    return GlobalsService.language;
  }

  get W3LLApplicationID() {
    return GlobalsService.sbe_saml.ApplicationID;
  }

  

  // get partnerPhone() {
  //   return GlobalsService.lookupPartnerPhoneNum(GlobalsService.partner);
  // }

  get partnerPhone() {
    const phn = {
      wy: '800 - 851 - 2227',
      nd: '800 - 280 - 2583',
      highmark: '1 - 888 - 510 - 1084'
    };

    // for FFM assign partner phone number based on the partners
    if(location.href.includes("ffm")) {
      this.app_Partner.isFFM = true;
      this.app_Partner.partner = this.app_Partner.isFFM && location.href.indexOf("=")!== -1? 
      location.href.slice(location.href.indexOf("=")+1, location.href.indexOf("&")):'highmark';
      return location.href.indexOf("=")!== -1? 
      phn[location.href.slice(location.href.indexOf("=")+1, location.href.indexOf("&"))]:phn['highmark'];
    } else if (GlobalsService.partner === "MN" && location.href.includes("SP")){
        if (GlobalsService.sbe_saml.UserType === "Member"){
        return '1-800-262-0823'; }
        else{
        return '1-800-262-0821'; }
    } else {
      return GlobalsService.lookupPartnerPhoneNum(GlobalsService.partner);
    }
  }

  //to get the FFM page status if the route contains FFM
  get FFMStatus() {
    if(location.href.includes("ffm")) {
      return true;
    } else {
      return false;
    }
  }

  get FFMWYNDStatus() {
    if (location.href.includes("partner=wy") || location.href.includes("partner=nd")) {
      return true;
    } else {
      return false;
    }
  }

  //to get the SP page status if the route contains SP
  get SPStatus() {
    if(location.href.includes("SP")) {
      return true;
    } else {
      return false;
    }
  }

  //to get the HS page status if the route contains HS
  get HSStatus() {
    if(location.href.includes("HealthSherpa")) {
      return true;
    } else {
      return false;
    }
  }

   //to get the W3LL page status if the route contains w3ll
   get W3LLStatus() {
    if(location.href.includes("w3ll")) {
      return true;
    } else {
      return false;
    }
  }

  // to show highmark partenr phone number for FFM
  get highmarkPartnerStatus() {
    if(location.href.includes("ffm") && !location.href.includes("partner")) {
      return true;
    } else {
      return false;
    }
  }

  /*
  setTotalAmountDue() {
    var totalAmountDue = 0;
    for (let i = 0; i < this.products.length; i++) {
      totalAmountDue += Number(this.products[i].productPrice);
    }
    this.totalAmountDue = totalAmountDue;
    this.payment.paymentAmount = this.totalAmountDue;
  }
  */

  // comment is added here

  get returnURL() {
    //return GlobalsService.saml.ReturnURL.split(':')[1];
    return '';
  }

  get totalAmountOwed() {
    return GlobalsService.sbe_saml.TotalAmountOwed;
  }

  get negtivetotalAmountOwed(){
    let temp: number = +GlobalsService.sbe_saml.TotalAmountOwed;
    if (temp === 0.00 || temp < 0.00)
    { 
      return true; } 
    else {
      return false;
    }
  }

  get aptcAmountOwed() {
    let APTCAmount : string;
    if (GlobalsService.sbe_saml.APTCAmount == '' || GlobalsService.sbe_saml.APTCAmount == null || GlobalsService.sbe_saml.APTCAmount == undefined) {
      APTCAmount = "0.00";
    } else {
      APTCAmount = GlobalsService.sbe_saml.APTCAmount;
    }
    return APTCAmount;
  }
  get subsidyValue() {
    let SubsidyValue : any;
    let tempValue : any;
    tempValue = (+GlobalsService.sbe_saml.PremiumAmountTotal - (+GlobalsService.sbe_saml.APTCAmount + +GlobalsService.sbe_saml.TotalAmountOwed));
    if (tempValue < 0.00) {
      SubsidyValue = "0.00";
    } else {
      SubsidyValue = tempValue;
    }
    return SubsidyValue;
  }
  get premiumMonthlyAmountOwed() {
    let PremiumAmountTotal : string;
    if (GlobalsService.sbe_saml.PremiumAmountTotal == '' || GlobalsService.sbe_saml.PremiumAmountTotal == null || GlobalsService.sbe_saml.PremiumAmountTotal == undefined) {
      PremiumAmountTotal = "0.00";
    } else {
      PremiumAmountTotal = GlobalsService.sbe_saml.PremiumAmountTotal;
    }
    return PremiumAmountTotal;
  }
  get emailAddress() {
    let mailId : string;
    if (GlobalsService.sbe_saml.ContactEmailAddress == '' || GlobalsService.sbe_saml.ContactEmailAddress == null || GlobalsService.sbe_saml.ContactEmailAddress == undefined) {
        mailId = "null@null.com";
    } else {
      mailId = GlobalsService.sbe_saml.ContactEmailAddress;
      
    }
    return mailId;
  }


  get PlanName() {
    return GlobalsService.sbe_saml.PlanName;
  }

  get ProductLineName() {
    return GlobalsService.sbe_saml.ProductLineName;
  }

  

  //new method - keep commented for now
  /*
  assignProductData() {
      var productDataArray = GlobalsService.saml.PlanName.split(',');
      if (productDataArray.length < 2 && !(productDataArray[0].includes('-'))) {
        var p = new Product();
        p.productType = productDataArray[0];
        p.productName = productDataArray[1];
        p.productPrice = GlobalsService.saml.PremiumAmountTotal;
        this.products.push(p);
      } else {
        for (let i = 0; i < productDataArray.length; i++) {
          var p = new Product();
          var productDetails = productDataArray[i].split('-');
          p.productType = productDetails[0];
          p.productName = productDetails[1];
          p.productPrice = productDetails[2];
          this.products.push(p);
        }
        this.payment.paymentAmount = Number.parseFloat(GlobalsService.saml.PremiumAmountTotal);
      }
  }
  */

  next() {
    if(this.payment.accountNumber) {
      this.accountLength = Array(this.payment.accountNumber.length-4);
    }
    this.stepper.next();
  }

  prev(text?: string) {
    if(text !== 'doNotClearPayment') {
      this.clearPaymentDetails();
      this.resetErrorMsgs();
    }
    this.stepper.previous();
    if ($("#consentCheckbox").prop("checked") === false) {
      $("#consentCheckbox").prop("checked", false);
    }
  }

  get f() { return this.paymentForm.controls; }

  backToFirstScreen() {
    $('#paymentModalRetry').modal('hide');
    $('#paymentModalRetryAHNJ').modal('hide');
    $('#paymentModalRetryACH').modal('hide');
    $('#paymentModalGIACTValidationError').modal('hide');
    $('#duplicateModalRetry').modal('hide');
    this.paymentSubmitStatus = false;
    this.yearControlTouched = false;
    this.monthControlTouched = false;
    this.stepper.reset();
    this.billingEmailAddrIsDifferent = false;
    this.payment.contactEmailAddress = GlobalsService.sbe_saml.ContactEmailAddress;
  }

  clearFunction() {
    this.clearPaymentDetails();
    this.paymentSubmitStatus = false;
    this.yearControlTouched = false;
    this.monthControlTouched = false;
  }

  assignModalMsgs(data, elseMsg: string) {
    if (data.errors[0].code === 'B13' || data.errors[0].code === 'N14' || data.errors[0].code === 'N15' || data.errors[0].code === 'N16' || data.errors[0].code === 'N18') {
      this.modalMsg = "routing_number_account_number_invalid";
    } else if (data.errors[0].code === 'N26') { 
      this.modalMsg = "debiblock_invalid";
    } else {
      this.modalMsg = elseMsg; 
    }
  }

  callGetBillModal() {
    $('#paymentModalGetBill').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  callRetryModal() {
    $('#paymentModalRetry').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  callAHNJRetryModal() {
    this.modalMsg = "retry_payment_SBE_AHNJ";
    $('#paymentModalRetryAHNJ').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  callGetBillIBCModal() {
    $('#paymentModalGetBillIBC').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  callUnavailableModal() {
    $('#paymentModalUnavailable').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  checkLanguage() {
    this.submitButton.nativeElement.disabled = false;
    if (GlobalsService.language == 'ES') {
      this.submitButton.nativeElement.innerText = 'Enviar';
    } else {
      this.submitButton.nativeElement.innerText = 'Submit';
    }
  }

  callDuplicateModal() {
    $('#duplicateModalRetry').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }
  onSubmit() {
    this.paymentSubmitStatus = true;
    this.loading = true;
    this.spinner.show();

    // if (true) { this.showSuccessMessage = true; } else {
    this.submissionAttempts++;
    // payload to form payment detail object
    if (this.payment.paymentType == 'Bank Account') {
      this.paymentDetailObj = new ACHPaymentDetailObj();
      this.paymentDetailObj.achAcctNum = this.payment.accountNumber;
      this.paymentDetailObj.achRtNum = this.payment.routingNumber;
      this.paymentDetailObj.pmtMthd = 'ACH';
      this.paymentDetailObj.pmtMthdType = (this.payment.achType === 'checking') ? 'DA' : 'SG';
      
      this.paymentDetailObj.custEmail = this.payment.contactEmailAddress;
      this.paymentDetailObj.businessNameBankAcct = this.payment.businessNameBankAcct;
      this.paymentDetailObj.accountHolderType = this.payment.accountHolderType;
      this.paymentDetailObj.firstNameBankAcct = this.payment.accountHolderFirstName;
      this.paymentDetailObj.lastNameBankAcct = this.payment.accountHolderLastName;
      if (this.payment.accountHolderType === 'personal') {
        this.paymentDetailObj.custDOB = new Date(this.payment.custDOB).toISOString();
      } else {
        this.paymentDetailObj.custDOB = '';
      }
    } else {
      this.paymentDetailObj = new CCPaymentDetailObj();
      this.paymentDetailObj.pmtMthd = 'CC';
      this.paymentDetailObj.dbType = '';
      if (this.payment.paymentType == 'Credit Card') {
        if (this.payment.cardType == 'Visa') {
          this.paymentDetailObj.ccCode = 'VI'; //Need to update once we get the info on pmtMthd
        } else if (this.payment.cardType == 'MasterCard') {
          this.paymentDetailObj.ccCode = 'MC';
        } else if (this.payment.cardType == 'American Express') {
          this.paymentDetailObj.ccCode = 'AX';
        } else if (this.payment.cardType == 'Discover') {
          this.paymentDetailObj.ccCode = 'DI';
        }
      } else if (this.payment.paymentType == 'Debit Card' || this.payment.paymentType == 'Prepaid Debit Card') {
        this.paymentDetailObj.ccCode = 'DB';
        if (this.payment.cardType == 'Visa') {
          this.paymentDetailObj.dbType = 'VI'; //Need to update once we get the info on pmtMthd
        } else if (this.payment.cardType == 'MasterCard') {
          this.paymentDetailObj.dbType = 'MC';
        } else if (this.payment.cardType == 'American Express') {
          this.paymentDetailObj.dbType = 'AX';
        } else if (this.payment.cardType == 'Discover') {
          this.paymentDetailObj.dbType = 'DI';
        }
      }
      this.paymentDetailObj.ccNum = this.payment.cardNumber;
      this.paymentDetailObj.ccExp = this.payment.expMonth + this.payment.expYear;
      this.paymentDetailObj.securityCode = this.payment.cvv;
    }

    /*
    if (GlobalsService.saml.PaymentAmount === null || GlobalsService.saml.PaymentAmount === '') {
      this.paymentDetailObj.pmtAmt = GlobalsService.saml.PremiumAmountTotal;
    } else {
      this.paymentDetailObj.pmtAmt = GlobalsService.saml.PaymentAmount;
    }
    */

    this.paymentDetailObj.pmtAmt = GlobalsService.sbe_saml.TotalAmountOwed;

    this.paymentDetailObj.pmtAmt = Number(this.paymentDetailObj.pmtAmt).toFixed(2);

    // Payload to form payment user object by using saml
    this.paymentPayload.ApplicationID = GlobalsService.SBE_ApplicationID;
    if (this.payment.accountHolderType === 'personal') {
      this.paymentPayload.FirstName = this.payment.accountHolderFirstName;
      this.paymentPayload.MiddleName = GlobalsService.sbe_saml.MiddleName;
      this.paymentPayload.LastName = this.payment.accountHolderLastName;
    } else {
      this.paymentPayload.FirstName = (this.payment.accountHolderFirstName != '') ? this.payment.accountHolderFirstName : GlobalsService.sbe_saml.FirstName;;
      this.paymentPayload.MiddleName = GlobalsService.sbe_saml.MiddleName;
      this.paymentPayload.LastName = (this.payment.accountHolderLastName != '') ? this.payment.accountHolderLastName : GlobalsService.sbe_saml.LastName;
    }

    if (GlobalsService.sbe_saml.ContactEmailAddress == '' || GlobalsService.sbe_saml.ContactEmailAddress == null) {
      this.paymentPayload.ContactEmailAddress = "null@null.com";
    } else {
      this.paymentPayload.ContactEmailAddress = GlobalsService.sbe_saml.ContactEmailAddress;
    }

    this.paymentPayload.StreetName1 = GlobalsService.sbe_saml.StreetName1;
    this.paymentPayload.StreetName2 = GlobalsService.sbe_saml.StreetName2;
    this.paymentPayload.State = GlobalsService.sbe_saml.State;
    this.paymentPayload.CityName = GlobalsService.sbe_saml.CityName;
    this.paymentPayload.ZipCode = GlobalsService.sbe_saml.ZipCode;

    if (this.payment.addrLine1 != null && this.payment.addrLine1 != '') {
      this.paymentPayload.StreetName1 = this.payment.addrLine1;
      this.paymentPayload.StreetName2 = this.payment.addrLine2;
      this.paymentPayload.State = this.payment.state;
      this.paymentPayload.CityName = this.payment.city;
      this.paymentPayload.ZipCode = this.payment.zip;
    }
    if (this.payment.contactEmailAddress != null && this.payment.contactEmailAddress != '') {
      this.paymentPayload.ContactEmailAddress = this.payment.contactEmailAddress;
    }
    if(location.href.includes("SP") || location.href.includes("HealthSherpa")){
      this.paymentPayload.Region = GlobalsService.sbe_saml.Region;
    }
    else{
      this.paymentPayload.Region = GlobalsService.partner;
    }

    // Assign platfrom as FFM/sp if user sumbit payment from FFM/sp epay portal
    if(location.href.includes("ffm")) {
      this.paymentPayload.Platform = 'FFM';
    } else if(location.href.includes("SP")) {
      this.paymentPayload.Platform = 'SP';
    } else if(location.href.includes("HealthSherpa")) {
      this.paymentPayload.Platform = 'HS';
    }else if(location.href.includes("w3ll")) {
      this.paymentPayload.Platform = 'W3LL';
    }else {
      this.paymentPayload.Platform = 'SBE';
    }

    this.paymentPayload.payment = this.paymentDetailObj;

    //validate and submit
    
    this.http.post<any>(this.sharedService.getURI('payment'), JSON.stringify(this.paymentPayload)).subscribe(data => {
      this.spinner.hide();
      this.paymentSubmitStatus = false;
      var tempPayId;
      if (data.paymentID != null && data.paymentID != '') {
        this.transactionID_ePay = data.paymentID;
        tempPayId = this.transactionID_ePay.substr(0, 4);
      }

      // redirect to the returnURL once the payment status get success
      if (data.paymentStatus === 'SUCCESS') {
        if(location.href.includes("w3ll")) {
          this.billMe = true;
          this.payOnline= true;
        }
        this.loading = false;
        this.checkLanguage(); // checks language and assign language specific text for the button
        this.cookieService.remove('existing_session_cookie')
        var o: existing_session_cookie_object = { "ApplicationID": null, "SBE_ID": null, "Platform": null, "Region": null, "LastPaymentDate": null, "LastPaymentAmount": null, "LastProposedCoverageEffectDate": null };
        o.ApplicationID = GlobalsService.SBE_ApplicationID;
        o.SBE_ID = GlobalsService.SBE_ConsumerReferenceID;
        o.Region = GlobalsService.SBE_Region;
        o.Platform = GlobalsService.SBE_Platform;
        o.LastPaymentDate = (new Date().toLocaleDateString("en-US")).toString();
        o.LastPaymentAmount = '$' + GlobalsService.sbe_saml.TotalAmountOwed;
        o.LastProposedCoverageEffectDate = GlobalsService.sbe_saml.ProposedCoverageEffectiveDate;
        //var escValue = btoa(JSON.stringify(o));
        var escValue = btoa(JSON.stringify(o).replace(/[\u00A0-\u2666]/g, function(c) {
          return '&#' + c.charCodeAt(0) + ';'; }));
        this.cookieService.put('existing_session_cookie', escValue);
        //window.location.href = data.returnURL;       
        this.showSuccessMessage = true;
        this.successfulCompletion = true;
      } else if (data.paymentStatus === 'ERROR') {
        this.checkLanguage(); // checks language and assign language specific text for the button
        this.loading = false;
        if (data.errors[0].code === '500') {
          this.callUnavailableModal();
        } else if (data.errors[0].code === 'D20') {
          this.modalMsg = "only_accept_ach_SBE";
          $('#paymentModalRetryACH').modal({
            backdrop: 'static',
            keyboard: false,
            show: true
          });
          this.clearPaymentDetails();
          this.isCardSuppressed = true;
          //GlobalsService.saml.SuppressCreditCard = 'Y';
          this.paymentSubmitStatus = false;
        } else if (tempPayId === "PYNC" || tempPayId === "PYND" || (String(data.paymentID).startsWith('HHP') && tempPayId !== "HHPB")) {
          
          this.assignModalMsgs(data, "payment_error_attempts_exceeded")
          this.callGetBillModal();
          this.clearFunction();

        } else if (tempPayId === "SBEC" || tempPayId === "SBED" || (String(data.paymentID).startsWith('HHP') && tempPayId !== "HHPB")) {
          if (String(data.paymentID).startsWith('SBE')) {
            this.assignModalMsgs(data, "payment_error_attempts_exceeded_IBC");
            this.callGetBillIBCModal();
          } else {

            this.assignModalMsgs(data, "payment_error_attempts_exceeded");
            this.callGetBillModal();

          }
          this.clearFunction();
        } else if (tempPayId === "FFMH" || tempPayId === "FFMW" || tempPayId === "FFMN" && (tempPayId !== "HHPB")) {

          this.assignModalMsgs(data,"payment_error_attempts_exceeded");
          this.callGetBillModal();
          this.clearFunction();

        } else if (tempPayId === "SPHM" || tempPayId === "SPWY" || tempPayId === "SPMN" || tempPayId === "SPND") {

          this.assignModalMsgs(data, "payment_error_attempts_exceeded");
          this.callGetBillModal();
          this.clearFunction();

        } else if (tempPayId === "PYNB" || tempPayId === "HHPB") {
          this.assignModalMsgs(data, "retry_payment_SBE");
          if (GlobalsService.partner == 'AHNJ') {
            this.callAHNJRetryModal();
          } else {
            this.callRetryModal();
          }
          this.clearFunction();
        } else if (tempPayId === "SBEB" || tempPayId === "HHPB") {
          this.assignModalMsgs(data,"retry_payment_SBE");
         
          if (GlobalsService.partner == 'AHNJ') {
            
            this.callAHNJRetryModal();
          } else {
            this.callRetryModal();
          }
          this.clearFunction();
        } else {
          this.assignModalMsgs(data,"retry_payment_SBE");
          
          if (GlobalsService.partner == 'AHNJ') {
            if(data.failureCount>=3) {  
              this.assignModalMsgs(data,"payment_error_attempts_exceeded_IBC");
              this.callGetBillIBCModal();
            } else { 
              this.callAHNJRetryModal();
            }
          } else {
            if(data.failureCount>=3) {
              this.assignModalMsgs(data, "payment_error_attempts_exceeded");
              this.showSendMeBill = true;
              this.callGetBillModal();
            } else {
              if(location.href.includes("w3ll")) {
                this.showSendMeBill = false;
                this.assignModalMsgs(data,"retry_payment_w3ll");
                this.callRetryModal();
                this.paymentSelectionMade = true;
                this.moveToStepper = true;
              } else {
                this.callRetryModal();
              }
            }
          }
          this.clearFunction();
        }
      } else if (data.paymentStatus === 'ADVERSE') {
        this.failureCount = parseInt(data.failureCount);
        this.showAdverseNotification = true;
        //this.adverseDetails.adverseNote = data.adverseNote;
        let emailAddress;
        if (this.payment.contactEmailAddress === 'null@null.com') {
          this.payment.contactEmailAddress = '';
        }
        if (this.emailAddress === 'null@null.com') {
          emailAddress = '';
        } else {
          emailAddress = this.emailAddress;
        }
        this.adverseDetails = {
          adverseNote: data.adverseNote,
          firstName: this.payment.accountHolderFirstName,
          lastName: this.payment.accountHolderLastName,
          acctName: GlobalsService.sbe_saml.FirstName + ' ' + GlobalsService.sbe_saml.LastName,
          businessName: this.businessName,
          merchantId: data.merchantId,
          referenceId: data.referenceId,
          productCode: data.productCode,
          memberEmailAddress: (this.billingEmailAddrIsDifferent || this.payment.contactEmailAddress != '') ? this.payment.contactEmailAddress : emailAddress,
          addressLine1: GlobalsService.sbe_saml.StreetName1,
          addressLine2: GlobalsService.sbe_saml.StreetName2,
          city: GlobalsService.sbe_saml.CityName,
          state: GlobalsService.sbe_saml.State,
          postalCode: GlobalsService.sbe_saml.ZipCode,
          UserType: (location.href.includes("SP") || location.href.includes("HealthSherpa")) ? GlobalsService.sbe_saml.UserType : 'MEMBER',
          partner: this.partner,
          failureCount: this.failureCount,
          language: GlobalsService.sbe_saml.Language,
          applicationId: data.applicationId
        };
        this.submitButton.nativeElement.disabled = false;
        this.adverseNotificationStatus = false;
        this.clearPaymentDetails();
        window.scroll(0,0);
      } else {
        
        this.checkLanguage(); // checks language and assign language specific text for the button
        this.loading = false;
        this.modalMsg = "retry_payment_SBE";
        if(data.errors[0].code === "64757065") {
          this.callDuplicateModal();
        }else if (GlobalsService.partner == 'AHNJ') {
        
          this.callAHNJRetryModal();
        } else {
          this.callRetryModal();
        }
        this.clearPaymentDetails();
        this.paymentSubmitStatus = false;
      }
      if (data.emailSentStatus === true){       
        this.emailSent = true;
      }
      else{
        this.emailSent = false;
      }
    },
      (error => {
        
        this.checkLanguage(); // checks language and assign language specific text for the button
        this.loading = false;
        this.spinner.hide();
        this.callUnavailableModal();
        this.paymentSubmitStatus = false;
      }));

    
    this.loading = false;
  }

  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  cvvInfo() {
    $('#cvvModal').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  cvvClose() {
    $('#cvvModal').modal('hide');
  }

  mouseover(formField) {
    (document.getElementById(formField) as any).type = 'text';
  }
  mouseout(formField) {
    (document.getElementById(formField) as any).type = 'password';
  }

  onKey(event) {
    //Shared fields
    if (event.target.name == 'accountHolderFirstName') {
      if (event.target.value == "" && this.payment.accountHolderType === 'personal') {
        this.fieldValidity.set('accountHolderFirstName', 'required');
      } else if (event.target.value != "" && (event.target.value.length < 3 || event.target.value.length > 40 || !(this.pureAlphaNumericPattern.test(event.target.value)))) {
        this.fieldValidity.set('accountHolderFirstName', 'invalid');
      } else {
        this.fieldValidity.set('accountHolderFirstName', '');
      }
    } else if (event.target.name == 'accountHolderLastName') {
      if (event.target.value == "" && this.payment.accountHolderType === 'personal') {
        this.fieldValidity.set('accountHolderLastName', 'required');
      } else if (event.target.value != "" && (event.target.value.length < 3 || event.target.value.length > 40 || !(this.pureAlphaNumericPattern.test(event.target.value)))) {
        this.fieldValidity.set('accountHolderLastName', 'invalid');
      } else {
        this.fieldValidity.set('accountHolderLastName', '');
      }
      //business name
    } else if (event.target.name == 'businessName') {
      if (event.target.value == "") {
        this.fieldValidity.set('businessName', 'required');
      } else if (event.target.value != "" && (event.target.value.length < 3 || event.target.value.length > 85 || !(this.pureAlphaNumericPattern.test(event.target.value)))) {
        this.fieldValidity.set('businessName', 'invalid');
      } else {
        this.fieldValidity.set('businessName', '');
      }
      //ACH fields
    } else if (event.target.name == 'routingNumber') {
      if (event.target.value == "") {
        this.fieldValidity.set('routingNumber', 'required');
      } else if (event.target.value.length != 9 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('routingNumber', 'invalid');
      } else {
        this.fieldValidity.set('routingNumber', '');
      }
    } else if (event.target.name == 'dateOfBirth') {
      this.isValidDate(event.target.value);
      if (event.target.value == "") {
        this.fieldValidity.set('dateOfBirth', 'required');
      } else if (!this.isValidDate(event.target.value)) {
        this.fieldValidity.set('dateOfBirth', 'invalid');
      } else if (!this.isValidDate1(event.target.value)) {
        this.fieldValidity.set('dateOfBirth', 'invalid');
      } else {
        this.fieldValidity.set('dateOfBirth', '');
      }
    } else if (event.target.name == 'accountNumber') {
      if (event.target.value == "") {
        this.fieldValidity.set('accountNumber', 'required');
      } else if (event.target.value.length < 4 || event.target.value.length > 17) {
        this.fieldValidity.set('accountNumber', 'invalid');
      } else if (this.payment.routingNumber === this.payment.accountNumber) {
        this.fieldValidity.set('accountNumber', 'mustdifferent');
      } else {
        this.fieldValidity.set('accountNumber', '');
      }
    } else if (event.target.name == 'accountNumberConfirmation') {
      if (event.target.value == "") {
        this.fieldValidity.set('accountNumberConfirmation', 'required');
      } else if (event.target.value != this.payment.accountNumber.valueOf()) {
        this.fieldValidity.set('accountNumberConfirmation', 'invalid');
      } else {
        this.fieldValidity.set('accountNumberConfirmation', '');
      }
    } else if (event.target.name == 'contactEmailAddress') {
      if (event.target.value == "") {
        this.emailFieldValid = true;
        this.fieldValidity.set('contactEmailAddress', 'required');
      } else if (!event.target.value.match('[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$')) {
        this.fieldValidity.set('contactEmailAddress', 'invalid');
        this.emailFieldValid = true;
      } else {
        this.fieldValidity.set('contactEmailAddress', '');
        this.emailFieldValid = false;
      }
    }
    //CCDC fields
    else if (event.target.name == 'cardNumber') {
      if (event.target.value == "") {
        this.fieldValidity.set('cardNumber', 'required');
      } else if (this.payment.cardType == "American Express"){
        if(event.target.value.length != 15 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('cardNumber', 'invalid');}
        else{
          this.fieldValidity.set('cardNumber', '');}
      } else if (event.target.value.length != 16 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('cardNumber', 'invalid');
      } else {
        this.fieldValidity.set('cardNumber', '');
      }
    } else if (event.target.name == 'cvv') {
      if (event.target.value == "") {
        this.fieldValidity.set('cvv', 'required');
      } else if (this.payment.cardType == "American Express"){
        if(event.target.value.length != 4 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('cvv', 'invalid');}
        else{
          this.fieldValidity.set('cvv', '');}
      } else if (event.target.value.length != 3 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('cvv', 'invalid');
      } else {
        this.fieldValidity.set('cvv', '');
      }
    } else if (event.target.name == 'addrLine1') {
      if (event.target.value == "") {
        this.fieldValidity.set('addrLine1', 'required');
      } else if (event.target.value.length < 5) {
        this.fieldValidity.set('addrLine1', 'invalid');
      } else {
        this.fieldValidity.set('addrLine1', '');
      }
    } else if (event.target.name == 'city') {
      if (event.target.value == "") {
        this.fieldValidity.set('city', 'required');
      } else if (event.target.value.length < 2 || (this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('city', 'invalid');
      } else {
        this.fieldValidity.set('city', '');
      }
    } else if (event.target.name == 'zip') {
      if (event.target.value == "") {
        this.fieldValidity.set('zip', 'required');
      } else if (event.target.value.length != 5 || !(this.numericReg.test(event.target.value))) {
        this.fieldValidity.set('zip', 'invalid');
      } else {
        this.fieldValidity.set('zip', '');
      }
    }
  }

  isValidDate1(strDate) {
    let latest_date = new DatePipe('en-Us').transform(this.currentDate, 'yyyy-MM-dd');
    if(strDate <= latest_date && new Date(strDate).getFullYear()>= 1900 &&  new Date(strDate).getFullYear() <= new Date(latest_date).getFullYear()) {
      return true
    } else {
      return false;
    }
  }
  
  isValidDate(strDate) {
    const dateValidationRegex = /^(0?[1-9]|1[0-2])[\/](0?[1-9]|[1-2][0-9]|3[01])[\/]\d{4}/;
    const dateValidationRegexone = /^\d{4}[\-](0?[1-9]|1[0-2])[\-](0?[1-9]|[1-2][0-9]|3[01])$/;
    if (!dateValidationRegex.test(strDate) && !dateValidationRegexone.test(strDate)) {
      return false;
    } else {
      return true;
    }
  }

  updateDate(event: any) {
    this.date = event.target.valueAsDate;
  }

  expDateInvalid() {
    var d = new Date();
    var currentMonth = d.getMonth() + 1;
    var currentYear = d.getFullYear();
    if ((Number(this.payment.expYear) + 2000) > currentYear) {
      return false;
    } else if((Number(this.payment.expYear) + 2000) === currentYear) {
      if(Number(this.payment.expMonth) >= currentMonth) {
        return false
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  clearPaymentDetails() {
    this.payment.paymentType = '';
    this.payment.routingNumber = '';
    this.payment.custDOB = '';
    this.payment.custEmail = '';
    this.payment.firstNameBankAcct = '';
    this.payment.lastNameBankAcct = '';
    this.payment.accountNumber = '';
    this.payment.accountNumberConfirmation = '';
    this.payment.paymentAmount = 0;
    this.payment.achType = '';
    this.payment.cardNumber = '';
    this.payment.accountHolderFirstName = '';
    this.payment.accountHolderLastName = '';
    this.payment.addrLine1 = '';
    this.payment.addrLine2 = '';
    this.payment.city = '';
    this.payment.state = '';
    this.payment.zip = '';
    this.payment.cardType = '';
    this.payment.expMonth = '';
    this.payment.expYear = '';
    // this.payment.contactEmailAddress = '';
    this.payment.businessNameBankAcct = '';
    this.payment.accountHolderType = 'personal';
    this.payment.cvv = '';
  }

  changeCardMethod() {
    this.cardDigit = this.payment.cardType === 'American Express'? '4': '3';
    this.cardLength = this.payment.cardType === 'American Express'? Array(11): Array(12);
    this.payment.cardNumber ='';
    this.payment.cvv = '';
    this.payment.expMonth = '';
    this.payment.expYear = '';
    this.fieldValidity.set('cvv', '');
    this.fieldValidity.set('cardNumber', '');
    this.monthControlTouched = false;
  }

  returnToPreSelect() {
    this.paymentSelectionMade = false;
    this.moveToStepper = false;
  }

  // send back the user to GWC
  returnToShopping() {
    this.modalMsg = "confirm_return_to_shopping";
    $('#paymentModalConfirmReturn').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
  }

  returnToShoppingConfirm() {
    history.go(-2);
  }

  returnToShoppingNevermind() {
    $('#paymentModalConfirmReturn').modal('hide');
  }

  printAdverse(): void {
      this.child.printAdverse('print-section');
  }

  adverseDataEventEmitter(adverseNotificationStatus){
    this.adverseNotificationStatus = adverseNotificationStatus;
  }

  reSubmitPayment(reSubmitPaymentStatus){
    if (reSubmitPaymentStatus === true && this.failureCount < 3) {
      this.showAdverseNotification = false;
      this.backToFirstScreen();
    } else if (reSubmitPaymentStatus === true && this.failureCount >= 3) {
      this.cancel();
    }
  }

  closeAdverse() {
    this.showAdverseNotification = false;
    if (this.failureCount >= 3) {
      this.cancel();
    } else {
      this.backToFirstScreen();
      this.payment.contactEmailAddress = GlobalsService.sbe_saml.ContactEmailAddress;
    }
  }

  bankaccountTypeSelect(event) {
    if (event === 'personal' ||  event === 'business')
    this.payment.accountHolderFirstName = '';
    this.payment.accountHolderLastName = '';  
    this.payment.businessNameBankAcct = '';
  }

  get fetchTermsPDFURL() {
    return "/billing/paynow/assets/" + GlobalsService.partner + "_terms_conditions.pdf";
  }


  openLink() {
    window.open(GlobalsService.pcpURL);
    }

    get customerEmailId() {
      if(!this.billingEmailAddrIsDifferent && (this.partner==='HHP' || this.partner==='MN' || this.partner==='ND' || this.partner==='WY')) {
        if(this.emailAddress === 'null@null.com' && this.SPStatus ) {
          return this.payment.contactEmailAddress;
        }  else {
         return  this.emailAddress;
        }
      } else {
        return this.payment.contactEmailAddress;
      }
    }
}

export class Product {
  ProductLineName: string;
  productName: string;
  productPrice: string;
}

export class existing_session_cookie_object {
  ApplicationID: string;
  SBE_ID: string;
  Region: string;
  Platform: string;
  LastPaymentDate: string;
  LastPaymentAmount: string;
  LastProposedCoverageEffectDate: string;
}
